import React from 'react';
import { motion } from 'framer-motion';
import { SectionLabel } from './SectionLabel';
import { systemSteps } from '../data/site';
export function System() {
  return <section id="system" className="border-b border-[#1a1a1a] bg-[#0c0c0c]" data-id="element-504" data-mp="1roqb18tldt7">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 lg:py-28" data-id="element-505" data-mp="6nnb6euxwdov">
        <SectionLabel data-id="element-506" data-mp="arl7khsvrae8">The fix</SectionLabel>

        <h2 className="mt-8 max-w-3xl text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-507" data-mp="ao77xhblpfah">
          Not six services. One machine that catches leads.
        </h2>
        <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-400" data-id="element-508" data-mp="kmv9l5ja3hs0">
          A lead comes in one end and leaves the other as a booked estimate, and you can see
          exactly where it went.
        </p>

        <ol className="mt-16 grid grid-cols-1 gap-x-10 gap-y-12 md:grid-cols-2" data-id="element-509" data-mp="ugc9mra0dt44">
          {systemSteps.map((s, i) => <motion.li key={s.step} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.45,
          delay: i * 0.06
        }} className="relative border-l border-[#1f1f1f] pl-7" data-id="element-510" data-mp="13eo5b7pqfh3f" data-mpi={i}>
              <span className="absolute -left-[5px] top-1.5 h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-511" data-mp="qxudfde0d6aa" />
              <p className="font-mono text-xs tracking-[0.2em] text-neutral-600" data-id="element-512" data-mp="1jm9kndqwekb2">{s.step}</p>
              <h3 className="mt-3 text-xl font-semibold text-white" data-id="element-513" data-mp="1emn3it7y8jwz">{s.title}</h3>
              <p className="mt-3 max-w-md leading-relaxed text-neutral-400" data-id="element-514" data-mp="19vx1npyqez71">{s.body}</p>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}